var exports = {
  "kL": "xdbfd91f1--691c4c--container",
  "gq": "xdbfd91f1--691c4c--container--injected",
  "Qq": "xdbfd91f1--691c4c--text",
  "wm": "xdbfd91f1--691c4c--logo",
  "cL": "xdbfd91f1--691c4c--builder",
  "DD": "xdbfd91f1--691c4c--title",
  "Kk": "xdbfd91f1--691c4c--icon",
};

module.exports = exports;
